const actions = {
    UPDATE_CLIENT_CONFIG_BEGIN: 'UPDATE_CLIENT_CONFIG_BEGIN',
    UPDATE_CLIENT_CONFIG_SUCCESS: 'UPDATE_CLIENT_CONFIG_SUCCESS',
    UPDATE_CLIENT_CONFIG_ERR: 'UPDATE_CLIENT_CONFIG_ERR',

    updateClientConfigBegin: () => {
        return {
            type: actions.UPDATE_CLIENT_CONFIG_BEGIN,
        };
    },

    updateClientConfigSuccess: (data) => {
        return {
            type: actions.UPDATE_CLIENT_CONFIG_SUCCESS,
            data,
        };
    },

    updateClientConfigErr: (err) => {
        return {
            type: actions.UPDATE_CLIENT_CONFIG_ERR,
            err,
        };
    },
};

export default actions;